export const API_BASE = 'https://chapur63.chapur.com/facturacion-clientes';
//export const API_BASE = 'http://localhost:8084/';
//export const API_BASE = "http://10.2.91.55:8080/quiosco-facturacion/";

export const requests = {
    fetchTiendas: "catalogo/tiendas",
    fetchUsoCFDI: "catalogo-fac/uso-cfdi",
    fetchRegimenFiscal: "catalogo-fac/regimen-fiscal",
    facturacionTienda: {
        validarOperacion: "facturacion/genera-factura-tienda" //"sercli/facturacion/valida-operacion-caja"
    },
    facturacionRestaurante: {
        validarOperacion: "facturacion/genera-factura-restaurante"//"sercli/facturacion/validar-folio-sva-facturacion"
    },
    facturacionEcommerce: {
        validarOperacion: "facturacion/genera-factura-ecommerce"
    },
    facturacionGeneral: {
        informarRFC:"facturacion/obten-info-factura", //"sercli/facturacion/valida-rfc"
        generarFactura: "facturacion/genera-factura" //"sercli/facturacion/resolver"
    },
    consultaFactura: {
        obtenerDocumentos: "facturacion/obten-docs-rfc"//"sercli/facturacion/checa-operacion-facturada-rfc"
    },
    facturacionMoto: {
        validarOperacion: "/facturacion/obten-datos-operacion",
        validarMoto: "/facturacion/obten-datos-moto"
    },
    login: {
        obtenerAcceso: "/facturacion/obten-acceso"
    }
};